import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PreferencesService } from 'src/app/services/sections/job/preferences.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { GenericModalComponent } from '../../../generic-modal/generic-modal.component';
import { sortBy } from 'lodash-es';
import { UserContactInfo } from 'src/app/models/user-contact-info.model';
import { ToastService } from 'src/app/services/ui/toast.service';
import { ToastType } from '../../../toast/models/toast-type.enum';
import { PageType } from 'src/app/models/enum/page-type.enum';
import { SettingsPreferences } from 'src/app/services/ui/models/settings-preferences.model';

@Component({
	selector: 'app-preferences-modal',
	templateUrl: './preferences-modal.component.html',
	styleUrls: ['../../../stylesheets/job-actions.scss', '../../../stylesheets/job-main.scss', '../../../stylesheets/job-inputs.scss', '../../../stylesheets/job-contacts.scss', './preferences-modal.component.scss']
})
export class PreferencesModalComponent implements OnInit {

	@ViewChild('preferencesModal', { static: true }) public preferencesModal: GenericModalComponent;

	public settingsForm: FormGroup;
	public self = this;

	public token: string = null;
	public pageType: PageType = null;
	public preferencesData: SettingsPreferences;
	public isPreferencesLoading = false;

	public readonly GlobalSettingsService = GlobalSettingsService;
	public readonly PageType = PageType;

	constructor(
		private preferencesService: PreferencesService
	) { }

	ngOnInit(): void {

		this.settingsForm = new FormGroup({
			isNotificationDisabled: new FormControl(null),
			isJobAutoSkipped: new FormControl(null),
			projectManager: new FormControl(null)
		});

		GlobalSettingsService.openPreferencesModal = (): void => {

			this.preferencesData = GlobalSettingsService.preferencesPayload;

			if (this.preferencesData.customers) {
				this.preferencesData.customers = sortBy(this.preferencesData.customers, [
					(customer: UserContactInfo) => customer.lastName.toLowerCase(),
					(customer: UserContactInfo) => customer.firstName.toLowerCase()
				]);
			}
			this.settingsForm.patchValue(this.preferencesData.preferences);
			this.token = this.preferencesData.token;
			this.pageType = this.preferencesData.pageType;

			if (this.preferencesData.preferences?.projectManagerId) {
				this.settingsForm.get('projectManager').setValue(this.preferencesData.customers.find(item => item.userAccountId === this.preferencesData.preferences.projectManagerId));
			}

			this.preferencesModal.open(this.preferencesData);
		};
	}

	public submitPreferences(): void {
		GlobalSettingsService.navigationBarActions.get('settingsModalOpen').isDisabled = true;
		this.isPreferencesLoading = true;

		const model = this.settingsForm.getRawValue();
		model.projectManagerId = model.projectManager?.userAccountId;

		this.settingsForm.disable();

		this.preferencesService.setPreferences(this.token, model)
			.subscribe(() => {
				this.preferencesData.preferences.isJobAutoSkipped = model.isJobAutoSkipped;
				this.preferencesData.preferences.isNotificationDisabled = model.isNotificationDisabled;
				this.preferencesData.preferences.projectManagerId = model.projectManagerId;

				GlobalSettingsService.navigationBarActions.get('settingsModalOpen').isDisabled = false;

				this.settingsForm.enable();
				this.preferencesModal.hide();
				this.isPreferencesLoading = false;
			}, () => {
				this.settingsForm.enable();
				this.isPreferencesLoading = false;
				GlobalSettingsService.navigationBarActions.get('settingsModalOpen').isDisabled = false;

				ToastService.pushToast({
					icon: 'error',
					text: 'Could not save the new settings! Please try again.',
					type: ToastType.Error
				});
			});
	}

}
